<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading && localInvoices && localInvoices.length">
      <p class="text-muted" v-for="o in localInvoices">
        <button @click="showInvoice(o.id)" class="btn btn-xs btn-info openInvoice">
          <i class="icon-fa icon-fa-eye"></i>
        </button>
        <strong>{{ o.id }}</strong> {{ o.comment }}, препаратов <strong>{{
          o.drugsPositions
        }}</strong>
        (<strong>{{ o.drugs }}</strong> з.у.) на сумму <strong>{{ Math.round(o.totalSum * 100) / 100 }}</strong></p>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import {updateOrderedDrugs} from "@/eventsBus/index";

export default {
  props: ['orderedDrugs'],
  data() {
    return {
      loading: false,
      localInvoices: null,
    }
  },
  created() {
    if (this.orderedDrugs === null) {
      this.getOrderedDrugs();
    }
    updateOrderedDrugs.$on(
      "updateOrderedDrugs",
      (data = {}) => {
        this.getOrderedDrugs();
      });
  },
  methods: {
    showInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    async getOrderedDrugs() {
      this.loading = true;
      const {data} = await api.index('/new/suppliers/orders?new=1');
      if (data.success) {
        this.localInvoices = data.records.reduce((acc, i) => {
          const detailsData = i.details.reduce((acc, d) => {
            acc.totalItems += +d.qty;
            acc.totalSum += (+d.qty * +d.income_price);
            return acc;
          }, {totalItems: 0, totalSum: 0})
          acc.push({
            id: i.id,
            comment: i.comment,
            created_at: i.created_at,
            discount: i.discount,
            discount_type: i.discount_type,
            drugsPositions: i.details.length,
            drugs: detailsData.totalItems,
            totalSum: detailsData.totalSum
          })
          return acc;
        }, []);
      } else {
        toastr['error'](data.message || 'получения закупок', 'Ошибка')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
button.btn.openInvoice {
  padding: 0px 2px !important;
}

p {
  margin-bottom: 1px;
  font-size: 12px;
}
</style>
